// THIS IS THE ARRAY USED BY THE FILTER
// CRITICAL FOR FRONTEND, DON'T DELETE!

const regionList = [
  {
    name: "Caribbean",
    Celebrity: ["Short Caribbean", "Long Caribbean", "7N Caribbean"],
    "Royal Caribbean": [
      "7N CARIBBEAN",
      "SHORT CARIBBEAN",
      "LONG CARIBBEAN",
      "CARIBNE",
    ],
  },
  {
    name: "Europe",
    Celebrity: ["Europe"],
    "Royal Caribbean": ["EUROPE"],
  },
  {
    name: "Repositioning/Transatlantic",
    Celebrity: ["Repos/Trnatl"],
    "Royal Caribbean": ["REPOS/TRNATL"],
  },
  {
    name: "Canals",
    Celebrity: ["Canals"],
    "Royal Caribbean": ["CANALS"],
  },
  {
    name: "Bermuda",
    Celebrity: ["Bermuda"],
    "Royal Caribbean": ["BERMUDA"],
  },
  {
    name: "Hawaii",
    Celebrity: ["Hawaii"],
    "Royal Caribbean": ["HAWAII"],
  },
  {
    name: "Asia",
    Celebrity: ["Asia"],
  },
  {
    name: "Australia/New Zealand/South Pacific",
    Celebrity: ["Aust/Nzl/Sopac"],
    "Royal Caribbean": ["AUST/NZL/SOPAC"],
  },
  {
    name: "Alaska",
    Celebrity: ["Alaska"],
    "Royal Caribbean": ["ALASKA"],
  },
  {
    name: "Canada",
    Celebrity: ["Canada"],
    "Royal Caribbean": ["CANADA"],
  },
  {
    name: "South America",
    Celebrity: ["Samerica"],
  },
  {
    name: "West Coast Short",
    "Royal Caribbean": ["WESTCOASTSHORT"],
  },
  {
    name: "Mexico",
    "Royal Caribbean": ["MEXICO"],
  },
];

module.exports = regionList;
